module.exports = __webpack_public_path__ + "static/media/disclaimer.9951e9cf.svg";